import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { SnippetDetailsResponse } from '../../../../shared/snippets';

import { getSnippetByIdQueryKey } from './shared';

//  Actual function to fetch the snippet by ID
async function getSnippetById(locator: string, snippetId: string) {
  return get<SnippetDetailsResponse>(`/api/revisions/${nuc(locator)}/snippets/${snippetId}`);
}

/**
 * useSnippetById is a hook that fetches and returns a specific snippet by its ID for the given locator.
 */
export default function useSnippetById(
  locator: string,
  snippetId: string,
  shouldFetch = true,
) {
  return useQuery<SnippetDetailsResponse>({
    queryKey: getSnippetByIdQueryKey(locator, snippetId),
    queryFn: () => getSnippetById(locator, snippetId),
    enabled: shouldFetch,
    // Invalidate after 10 seconds.
    staleTime: 10 * 1000,
  });
}
